import { TifPassengersIcon } from '@/components/icons/tif/TifPassengersIcon';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import { useSelector } from '@/store/utils';
import { Icons, type IconProps } from '@packages/webshop-design-system';

export const PassengersIcon = (props: IconProps) => {
  const { value: tenant } = useSelector(tenantSelector);

  const IconComponent = tenant === 'tifrance' ? TifPassengersIcon : Icons.users;

  return <IconComponent {...props} />;
};
